import { Direction, Locale } from "@/types/auth";

const LOCALE_KEY = "athr_locale";

export function getDirection(locale: Locale): Direction {
  return locale === "ar" ? "rtl" : "ltr";
}

export function getInitialLocale(): Locale {
  if (typeof window === "undefined") return "ar";
  const value = window.localStorage.getItem(LOCALE_KEY);
  return value === "en" ? "en" : "ar";
}

export function setLocaleStorage(locale: Locale): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(LOCALE_KEY, locale);
}
